import baseUrl from "../utils/baseUrl";
import axios from "./api";

const getPointsByMechanic = async (userId, mechanicId) =>
    await axios
        .get(baseUrl + `/client-points/user/${userId}/mechanic/${mechanicId}`)
        .then((response) => response.data);

const getAllPointsByUser = async (userId) =>
    await axios
        .get(baseUrl + `/client-points/user/${userId}`)
        .then((response) => response.data);

const createPoints = async (request) =>
    await axios
        .post(baseUrl + `/client-points`, request)
        .then((response) => response.data);

const updatePoints = async (request) =>
    await axios
        .put(baseUrl + `/client-points`, request)
        .then((response) => response.data);

const deletePoints = async (userId, mechanicId) =>
    await axios
        .delete(baseUrl + `/client-points/user/${userId}/mechanic/${mechanicId}`)
        .then((response) => response.data);

const getLogPaginationQuery = (page, size) =>
    page !== undefined && size !== undefined ? `?page=${page}&size=${size}` : "";

const getLogsByMechanic = async (mechanicId, page, size) =>
    await axios
        .get(baseUrl + `/client-points-log/mechanic/${mechanicId}${getLogPaginationQuery(page, size)}`)
        .then((response) => response.data);

const getLogsByUserAndMechanic = async (userId, mechanicId, page, size) =>
    await axios
        .get(baseUrl + `/client-points-log/user/${userId}/mechanic/${mechanicId}${getLogPaginationQuery(page, size)}`)
        .then((response) => response.data);

const getLogsByUser = async (userId, page, size) =>
    await axios
        .get(baseUrl + `/client-points-log/user/${userId}${getLogPaginationQuery(page, size)}`)
        .then((response) => response.data);

export {
    getPointsByMechanic,
    getAllPointsByUser,
    createPoints,
    updatePoints,
    deletePoints,
    getLogsByMechanic,
    getLogsByUserAndMechanic,
    getLogsByUser,
};
